<template>
    <div class="payload-wrapper">
        <AttributeSetUpdater
            v-for="(attribute, i) in clone"
            v-model="clone[i]"
            :show-remove-button="true"
            :on-removed="() => removeAttribute(i)"
            :key="'attr-' + attribute.attribute + i"
        />

        <button class="cbcard-btn" @click="addAttribute">
            <md-icon>add</md-icon>
        </button>
    </div>
</template>

<script>
import AttributesContext from "../AttributesContext";
import AttributeSetUpdater from "../common/AttributeSetUpdater";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";

const log = log2("SetAttribute");
export default {
    name: "SetAttribute",
    components: { AttributesContext, AttributeSetUpdater },
    props: ["value", "Payloads"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        addAttribute() {
            log("addAttribute");
            this.clone.push(_.cloneDeep(this.Payloads.SET_ATTRIBUTE.default[0]));
        },
        removeAttribute(index) {
            log("addAttribute");
            this.clone.splice(index, 1);
        },
    },
    mounted() {
        log("mounted", this.clone);
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                log("clone changed", newValue);
                this.$emit("input", this.clone);
            },
        },
    },
};
</script>

<style scoped></style>
